export default __webpack_public_path__ + "static/media/ASRM.4f35ef74.pdf";